module.exports = __webpack_public_path__ + "img/noData.aada0bb6.png";